import jQuery from 'jquery/dist/jquery.min';
let $ = jQuery;
window.jQuery = $;
window.$ = $;

let headerColors = [
    '#f00',
    '#090',
    '#00f',
    'orange',
];
let randomColor = () => headerColors[Math.floor(Math.random() * headerColors.length)];
$('#header .logo span').on('mouseover', ev => {
    ev.target.style.color = randomColor();
})
